import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
// import withStyles from "@material-ui/core/styles/withStyles";
import "./styles.css";
import "animate.css/animate.css";
import Splotch from "../../images/Splotch.svg"
const EvaluatorModal = ({
  classes,
  handleReloadClick
}) => {
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh", justifyContent: "center" }}
      >
        <Grid className="evaluatorModalContainer">
          <img src={Splotch} alt="" style={{ height: 100 }}/>
          {/* <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "Fiscal Policy is <i>very</i> hard to get right!" }} /> */}
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "In denim dyeing, chemicals used to help indigo adhere to fabric can pollute nearby waterways if the wastewater is untreated." }}>
          </Typography>
          {/* <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "Here’s how the slot machine works: the first reel is the downturn cause, the second reel is the policy and the third reel is the details of the implementation." }}>
          </Typography>
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "You have to nail all three for Fiscal Policy to revive the economy." }}>
          </Typography> */}
          {/* <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "So, ready? See if you “Keynes” can hit the fiscal policy jackpot!" }}>
          </Typography> */}
          <Grid container style={{ justifyContent: "center" }}>
            <Button className="submitButton" onClick={() => handleReloadClick()}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EvaluatorModal;
